// extracted by mini-css-extract-plugin
export default {"products":"Zv-z","card":"_v-z","oosMessaging":"aw-z"};